<template>
	<div class="body-boxs">
		<div class="fl-left">
			<!-- 标题 -->
			<div class="editTitle">正在编辑的商品</div>
			<div class="lf-left">
				<img style="width: 700px; height: auto;max-width: auto;max-height: auto;" :src="imgUrl" />
				<div class="bt-an">
					<el-button size="mini" class="imgbtn" @click="deleteImg">删除</el-button>
					<el-upload ref="upload" class="upload-demo" action="" :auto-upload="false" :file-list="fileList" :on-change="handleChange">
						<el-button size="mini" class="imgbtn">上传</el-button>
					</el-upload>
				</div>
			</div>
			<!-- 富文本编辑器 -->
			<div class="editbox">
				<editor
					id="editor_id"
					height="500px"
					width="700px"
					:content.sync="editorText"
					:afterChange="afterChange()"
					:loadStyleMode="false"
					@on-content-change="onContentChange"
				></editor>
			</div>
		</div>
		<!-- 右侧内容 -->
		<div class="box-rig">
			<p class="rig-p">手机扫一扫，预览最新效果</p>
			<!-- 二维码图片 -->
			<div class="erweima"><img v-if="pirtuer.imgUrl != ''" :src="pirtuer.basUrl + pirtuer.imgUrl" /></div>
			<div class="ri-btn" style="margin-top: 10px;">
				<el-button type="primary" size="mini" class="btn" @click="prevDilog">预览</el-button>
				<el-button type="primary" size="mini" class="btn" @click="presCove">保存</el-button>
			</div>
			<div class="hengxian">
				<h3 class="duoxuan-p">选择码制</h3>
				<div class="checkbox-box">
					<el-checkbox-group v-model="checkbox" @change="checkboxSelect">
						<el-checkbox :label="3">汉信码</el-checkbox>
						<el-checkbox :label="6">龙贝码</el-checkbox>
						<el-checkbox :label="9">GM码</el-checkbox>
						<el-checkbox :label="10">QR码</el-checkbox>
					</el-checkbox-group>
				</div>
				<h3 class="duoxuan-p">选择码标</h3>
				<div class="select-box">
					<el-select v-model="mark" placeholder="请选择" @change="markSelect">
						<el-option v-for="(item, index) in markOptions" :key="index" :label="item.identification" :value="item.identification_ID"></el-option>
					</el-select>
				</div>
				<el-button type="warning" @click="downLoad">打包下载码图</el-button>
			</div>
		</div>
		<!-- 码图设置弹窗 DisPreview-->
		<el-dialog title="预览" :visible.sync="DistQRSet" width="20%">
			<div class="QRsetEerweima"><img style="width: 100%; height: auto; object-fit: fill;" src="../assets/imgs/erweima.jpg" /></div>
			<!--tab栏  -->
			<div class="QEsetTab">
				<el-tabs v-model="activeName" @tab-click="handleClick">
					<el-tab-pane label="基本设置" name="first">
						<div class="seleTab">
							<label class="labletxt">应用分类:</label>
							<el-select v-model="value" placeholder="请选择">
								<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
							</el-select>
						</div>
						<div class="seleTab">
							<label class="labletxt">边框样式:</label>
							<!-- <el-select v-model="frame" placeholder="请选择" size="mini">
								<el-option v-for="(item, index) in borderList" :key="index" :label="item.borderName" :value="item.borderName"></el-option>
							</el-select> -->
						</div>
						<div class="seleTab">
							<label class="labletxt">图码尺寸:</label>
							<el-select v-model="value" placeholder="请选择">
								<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
							</el-select>
						</div>
					</el-tab-pane>
					<el-tab-pane label="修改颜色" name="second">
						<div class="seleTab SeleColor">
							<label class="labletxt">码图颜色：</label>
							<el-color-picker v-model="color" show-alpha :predefine="predefineColors"></el-color-picker>
							<label>仅QR码有效</label>
						</div>
					</el-tab-pane>
				</el-tabs>
			</div>
			<div class="QRSetBut">
				<el-button type="primary" class="el-but">保存</el-button>
				<el-button type="primary" class="el-but">取消</el-button>
			</div>
		</el-dialog>
		<!-- 预览弹窗编辑 -->
		<el-dialog title="预览" :visible.sync="DisPreviewEdit" width="330px" custom-class="previewContent-box">
			<div class="previewBoxs">
				<!-- <p>{{ moduleList.head.name }}</p>
			 <div v-if="moduleList.head.cover != ''"><img :src="moduleList.head.cover" /></div> -->
				<div v-html="moduleList.content.content" class="contentImg-boxs"></div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import editor from '../views/kindeditor.vue'; // 国控
export default {
	name: 'GoodsCodeEdit',
	components: { editor },
	data() {
		return {
			editor: null,
			activeName: 'first',
			editorContent: '',
			yearShowOne: false,
			checkbox: [10],
			editorText: '',
			value: '普通码',
			DisPreviewEdit: false, // 预览弹窗
			options: [
				{
					value: '普通码',
					label: '普通码'
				}
			],
			value: '',
			mark: '', //
			DistQRSet: false, // 图码设置弹窗
			color: 'rgba(255, 69, 0, 0.68)',
			predefineColors: [
				'#ff4500',
				'#ff8c00',
				'#ffd700',
				'#90ee90',
				'#00ced1',
				'#1e90ff',
				'#c71585',
				'rgba(255, 69, 0, 0.68)',
				'rgb(255, 120, 0)',
				'hsv(51, 100, 98)',
				'hsva(120, 40, 94, 0.5)',
				'hsl(181, 100%, 37%)',
				'hsla(209, 100%, 56%, 0.73)',
				'#c7158577'
			],
			idcode: '',
			moduleList: {
				head: {
					cover: '',
					name: ''
				},
				content: {
					content: ''
				}
			}, //预览数据
			markOptions: [], // 边框列表
			identificationID: '',
			pirtuer: {
				basUrl: '', // 图片地址(前半部分)
				imgUrl: '', // 图片名称(拼接路径后半部分)
				DM: '', // DM 码
				GM: '', // GM码
				QR: '', // QR码
				hanxin: '', // 汉信码
				longbei: '' // 龙背码
			},
			fileList: [],
			imgUrlList: [], //二维码选择数组
			imgUrl: '',
			name: '',
			content: '',
			addEnter: false, // 是否是新增页面进入
			addFile: false //是否上传过文件
		};
	},
	computed: {},
	created() {
		this.addFile = false;
		var query = this.$route.query;
		if (query.hasOwnProperty('tabimgurl')) {
			// if(query.tabimgurl.indexOf('http') != -1){
			// 	this.imgUrl = query.tabimgurl;
			// }else{
			// 	this.imgUrl = require(query.tabimgurl);
			// }
			this.imgUrl = query.tabimgurl;
		}
		if (query.hasOwnProperty('html')) {
			this.editorText = query.html;
		} else {
			if (query.hasOwnProperty('name') && query.hasOwnProperty('tabimgurl') && query.hasOwnProperty('content')) {
				this.editorText = query.name + '<br/>' + "<img src='" + this.imgUrl + "'/><br/>" + query.content;
			}
		}

		if (query.hasOwnProperty('name')) {
			this.name = query.name;
		}

		if (query.hasOwnProperty('content')) {
			this.content = query.content;
		}
		if (query.hasOwnProperty('idcode')) {
			this.idcode = query.idcode;
			this.addEnter = false;
		} else {
			this.addEnter = true;
		}

		if (this.$route.query.judedit === '1') {
			this.juedit();
		}

		this.QRq();
	},
	methods: {
		// 判断是否是从编辑进来的
		juedit() {
			// 如果等于1 重新调接口
			this.$http
				.get(this.$api + '/lightapp/getLightAppByIdcode', {
					params: {
						idcode: this.idcode
					}
				})
				.then(
					res => {
						if (res.body.hasOwnProperty('entity')) {
							if (res.body.entity.hasOwnProperty('moduleList')) {
								this.editorText = res.body.entity.moduleList.content.content;
								this.imgUrl = res.body.entity.moduleList.head.cover;
								this.name = res.body.entity.moduleList.head.name;
							}
						}
					},
					rej => {}
				);
		},
		// 获取码标列表
		QRq() {
			this.$http.get(this.$api + '/lightapp/getIdentificationList', {}).then(
				res => {
					console.log('获取码标列表');
					console.log(res);
					this.markOptions = [];
					if (res.body.hasOwnProperty('entity')) {
						this.markOptions = res.body.entity;
						if (res.body.entity.length != 0) {
							this.mark = res.body.entity[0].identification_ID;
							this.identificationID = res.body.entity[0].identification_ID;
							if (this.idcode) {
								this.QRPictuer();
							}
						}
					}
				},
				rej => {}
			);
		},
		// 获取二维码图
		QRPictuer() {
			this.$http
				.get(this.$api + '/CodeImage/createCodeImage', {
					params: {
						idcode: this.idcode, // 唯一编码
						identificationID: this.mark // 码标ID
					}
				})
				.then(
					res => {
						console.log(res, '二维码图');
						console.log(res.body.entity, '二维码图555');
						console.log(res.body.entity.imgList.DM码, '二维码图');
						if (res.body.result === 1) {
							this.pirtuer.basUrl = res.body.entity.baseUrl; // 图片地址
							this.pirtuer.DM = res.body.entity.imgList.DM码; // DM 码
							this.pirtuer.GM = res.body.entity.imgList.GM码; // GM码
							this.pirtuer.QR = res.body.entity.imgList.QR码; // QR码
							this.pirtuer.hanxin = res.body.entity.imgList.汉信码; // 汉信码
							this.pirtuer.longbei = res.body.entity.imgList.龙贝码; // 龙贝码
							this.pirtuer.imgUrl = this.pirtuer.QR;
							this.checkboxSelect();
						}
					},
					rej => {}
				);
		},
		// 图片上传
		handleChange(file, fileList) {
			this.fileList = fileList;
			var data = new FormData();
			data.append('file', file.raw);
			this.$http.post(this.$api + '/upload/uploadImageFile', data).then(
				res => {
					this.imgUrl = '';
					if (res.body.hasOwnProperty('entity')) {
						if (res.body.entity.hasOwnProperty('imageUrl') && res.body.entity.hasOwnProperty('imageBig')) {
							this.imgUrl = res.body.entity.imageUrl + res.body.entity.imageBig;
							console.log(this.imgUrl, '图片拼接地址更换');
							this.$message({
								showClose: true,
								message: '图片上传成功',
								type: 'success'
							});
							this.addFile = true;
							this.fileList = [];
							this.$refs.upload.clearFiles();
							this.$forceUpdate();
						}
					}
					console.log(res);
				},
				rej => {}
			);
		},
		// 图片删除
		deleteImg() {
			this.imgUrl = '';
		},
		//  预览弹窗
		prevDilog() {
			if (this.idcode == '') {
				this.$message({
					message: '请先保存！',
					type: 'warning'
				});
				return;
			}
			this.DisPreviewEdit = false;
			this.$http
				.get(this.$api + '/lightapp/getLightAppByIdcode', {
					params: {
						idcode: this.idcode //
					}
				})
				.then(
					res => {
						if (res.body.hasOwnProperty('entity')) {
							if (res.body.entity.hasOwnProperty('moduleList')) {
								this.moduleList.head.cover = res.body.entity.moduleList.head.cover;
								this.moduleList.head.name = res.body.entity.moduleList.head.name;
								this.moduleList.content.content = res.body.entity.moduleList.content.content;
							}
						}
						this.DisPreviewEdit = true;
					},
					rej => {}
				);
		},
		// 二维码选择
		checkboxSelect() {
			if (this.checkbox.indexOf(3) != -1) {
				this.imgUrlList.push(this.pirtuer.hanxin);
				// this.pirtuer.imgUrl = this.pirtuer.hanxin;
			} else {
				var i = this.imgUrlList.indexOf(this.pirtuer.hanxin);
				if (i != -1) {
					this.imgUrlList.splice(i, 1);
				}
			}
			if (this.checkbox.indexOf(6) != -1) {
				this.imgUrlList.push(this.pirtuer.longbei);
				// this.pirtuer.imgUrl = this.pirtuer.longbei;
			} else {
				var i = this.imgUrlList.indexOf(this.pirtuer.longbei);
				if (i != -1) {
					this.imgUrlList.splice(i, 1);
				}
			}
			if (this.checkbox.indexOf(9) != -1) {
				this.imgUrlList.push(this.pirtuer.GM);
				// this.pirtuer.imgUrl = this.pirtuer.GM;
			} else {
				var i = this.imgUrlList.indexOf(this.pirtuer.GM);
				if (i != -1) {
					this.imgUrlList.splice(i, 1);
				}
			}
			if (this.checkbox.indexOf(10) != -1) {
				this.imgUrlList.push(this.pirtuer.QR);
				// this.pirtuer.imgUrl = this.pirtuer.QR;
			} else {
				var i = this.imgUrlList.indexOf(this.pirtuer.QR);
				if (i != -1) {
					this.imgUrlList.splice(i, 1);
				}
			}
		},
		// 码标选择
		markSelect() {
			this.imgUrlList = [];
			this.QRPictuer();
		},
		//  图码设置tab栏
		handleClick(tab, event) {
			console.log(tab, event);
		},
		downLoad() {
			console.log('选择');
			console.log(this.imgUrlList.toString());
			if (this.imgUrlList.length == 0) {
				this.$message({
					message: '请选择码标',
					type: 'warning'
				});
				return;
			}
			location.href = this.$api+ "/CommonMethod/ZipDownloadsBatch/?fileNames=" + this.imgUrlList.toString() + "&filePath=CreateCode";
		},
		presCove() {
			if (this.addEnter) {
				if (!this.addFile) {
					this.$message({
						message: '请先上传图片再保存',
						type: 'warning'
					});
					return;
				}
			}
			var moduleList = {
				head: {},
				content: {}
			};
			if (this.imgUrl) {
				var arr = this.imgUrl.split('/');
				var len = arr.length;
				if (len != 0) {
					if (arr[len - 1].indexOf('.')) {
						moduleList.head.cover = arr[len - 1];
					}
				}
			}
			if (this.name) {
				moduleList.head.name = this.name;
			} else {
				moduleList.head.name = '空白模板';
			}
			if (this.editorText) {
				moduleList.content.content = this.editorText;
			}
			var data = {
				template_id: this.$route.query.template_id,
				moduleList: moduleList
			};
			if (this.idcode) {
				data.idcode = this.idcode;
			}
			this.$http.post(this.$api + '/lightapp/saveProductCode', JSON.stringify(data)).then(function(res) {
					if (res.body.result == 1) {
						  if (res.body.hasOwnProperty('entity')) {
						      this.idcode = res.body.entity.idcode;
						      this.QRPictuer();
					         }
							this.$message({
								message: res.body.message,
								type: 'success'
							});
						}else{
                            this.$message({
								message: res.body.message,
								type: 'success'
							});
						}
                     
					  
					
					
				},
				function(res) {
					console.log(res.status);
				}
			);
		},
		//  码图设置
		QRSet() {
			this.DistQRSet = true;
			// 获取边框列表
			// this.$http.get(this.$api + '/CodeImage/getBorderType', {}).then(
			// 	res => {
			// 		console.log('获取边框列表');
			// 		console.log(res);
			// 		this.borderList = [];
			// 		if (res.body.hasOwnProperty('entity')) {
			// 			this.borderList = res.body.entity;
			// 			if (res.body.entity.length != 0) {
			// 				this.frame = res.body.entity[0].borderName;
			// 				this.borderName = res.body.entity[0].borderName;
			// 			}
			// 		}
			// 	},
			// 	rej => {}
			// );
			// 获取码图样式设置
			// this.$http.get(this.$api + '/CodeImage/getCodeImageSet', {}).then(
			// 	res => {
			// 		console.log('获取码图样式设置');
			// 		console.log(res);
			// 	},
			// 	rej => {}
			// );
		},
		onContentChange(val) {
			this.editorTextCopy = val;
			console.log('富文本');
			console.log(this.editorTextCopy);
		},
		afterChange(val) {
			// debugger
			// this.editorTextCopy = val;
			// console.log('富文本1');
			// console.log(val);
		}
	}
};
</script>
<style scoped lang="scss">
.body-boxs {
	width: 100%;
	height: 100%;
	position: relative;
	margin: 0 auto;
	background-color: #f0f0f0 !important;
	display: flex;
	justify-content: center;
	// align-items: center;
	overflow-y: auto;
}
.fl-left {
	width: 700px;
	height: 100%;
	margin-right: 50px;
}
.lf-left {
	// width: 660px;
	position: relative;
	min-height: 175px;
	background: #f0f0f0;
	display: flex;
	justify-content: space-between;
	align-items: center;
	border: 1px solid #fff;

	::v-deep {
		.el-upload-list {
			display: none;
		}
	}
}
.bt-an {
	position: absolute;
	right: 15px;
	top: 30px;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	button {
		margin-left: 0 !important;
	}

	button:last-child {
		margin-top: 15px !important;
	}
}
.editbox {
	margin-top: 40px;
}
.editTitle {
	font-size: 22px;
	color: #5a5a5a;
	display: flex;
	margin: 50px 0 36px 0;
	line-height: 50px;
}
.imgbtn {
	background-color: white;
	border: 1px solid #d9d9d9;
	cursor: pointer;
}
.box-rig {
	width: 333px;
	height: 486px;
	background: #fff;
	padding: 25px 0px;
	display: flex;
	justify-content: center;
	flex-direction: column;
	align-items: center;
	margin-left: 50px;
	margin-top: 130px;
}
.rig-p {
	text-align: center;
	line-height: 25px;
	font-size: 13px;
	margin-top: 8px;
}

//    二维码
.erweima {
	height: 185px;
}
img {
	width: auto;
	height: auto;
	max-width: 100%;
	max-height: 100%;
}
ri-btn {
	width: 94%;
	text-align: center;
	margin: 15px 0;
	display: flex;
	justify-content: center;
	align-items: center;
}
.btn {
	height: 26px;
	border-radius: 2px;
}
.hengxian {
	border-top: 1px solid #d2d2d2;
	margin-top: 10px;
	padding: 20px 0;
}
.duoxuan-p {
	text-align: center;
    font-size: 16px; 
    font-weight: normal;
    margin: 14px 0;
}
.checkbox-box {
	white-space: nowrap;
	width: 100%;
	margin-bottom: 15px;
	::v-deep {
		.el-checkbox {
			margin-right: 15px;
		}
	}
}

.select-box {
	width: 100%;
	margin-bottom: 15px;
}
// 图码设置
.QRsetEerweima {
	width: 70%;
	margin: 0 auto;
}
// tab 栏
.QEsetTab {
	width: 70%;
	height: 234px;
	margin: 0 auto;
	text-align: left !important;
}
// 选择框 样式
.seleTab {
	margin-bottom: 20px;
	display: flex;
	flex-direction: row;
}
.labletxt {
	width: 80px;
	text-align: right;
	display: flex;
	align-items: flex-start;
	align-content: flex-start;
	justify-content: center; /* 水平居中 */
	align-items: center; /* 垂直居中 */
}
.SeleColor {
	margin-left: -77px;
	display: flex;
	flex-direction: row;
	justify-content: center; /* 水平居中 */
	align-items: center; /* 垂直居中 */
}
.QRSetBut {
	display: flex;
	flex-direction: row;
	justify-content: space-around;
}
.el-but {
	width: 40%;
	height: 40px;
	border-radius: 10px;
}
</style>

<style lang="scss">
// 预览弹窗
.previewContent-box {
	.previewBoxs {
		.contentImg-boxs {
			img {
				width: 300px;
				height: auto;
				object-fit: scale-down;
				margin: 0 auto;
			}
		}
	}
}
</style>
